/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StaffCouponLastActionDto { 
    type?: StaffCouponLastActionDto.TypeEnum;
    at?: string;
    staffName?: string;
    statusAtAction?: StaffCouponLastActionDto.StatusAtActionEnum;
}
export namespace StaffCouponLastActionDto {
    export type TypeEnum = 'SCAN_COUPON' | 'REDEEM_COUPON';
    export const TypeEnum = {
        ScanCoupon: 'SCAN_COUPON' as TypeEnum,
        RedeemCoupon: 'REDEEM_COUPON' as TypeEnum
    };
    export type StatusAtActionEnum = 'ACTIVE' | 'EXPIRED' | 'REDEEMED' | 'TO_BE_REDEEMED' | 'CANCELLED';
    export const StatusAtActionEnum = {
        Active: 'ACTIVE' as StatusAtActionEnum,
        Expired: 'EXPIRED' as StatusAtActionEnum,
        Redeemed: 'REDEEMED' as StatusAtActionEnum,
        ToBeRedeemed: 'TO_BE_REDEEMED' as StatusAtActionEnum,
        Cancelled: 'CANCELLED' as StatusAtActionEnum
    };
}


